<template lang="pug">
  #appFooter.appFooter.appFooter-sa
    .container.h-100
      .row.align-items-center.h-100
        .col-3.text-center
          b-img(
            :src="iconUrl.IconMsgWhite",
            fluid,
            alt="Footer Message",
            width="33",
            height="33",
            @click="routerPushHandler('Message')"
          )
        .col-3.text-center
          b-img(
            :src="iconUrl.IconContactsWhite",
            fluid,
            alt="Footer Contacts",
            width="33",
            height="33",
            @click="routerPushHandler('Contacts')"
          )
        .col-3.text-center
          b-img(
            :src="iconUrl.IconQRCodeWhite",
            fluid,
            alt="Footer QRCode",
            width="33",
            height="33",
            @click="routerPushHandler('QRCode')"
          )
        .col-3.text-center
          b-img(
            :src="iconUrl.IconItemsWhite",
            fluid,
            alt="Footer Items",
            width="33",
            height="33",
            @click="routerPushHandler('Items')"
          )

</template>

<script>
import IconMsgWhiteUrl from '@/assets/images/icon/icon_msg_white.png';
import IconContactsWhiteUrl from '@/assets/images/icon/icon_contacts_white.png';
import IconQRCodeWhiteUrl from '@/assets/images/icon/icon_qrcode_white.png';
import IconItemsWhiteUrl from '@/assets/images/icon/icon_items_white.png';

export default {
  name: 'appSaFooter',
  data() {
    return {
      iconUrl: {
        IconMsgWhite: IconMsgWhiteUrl,
        IconContactsWhite: IconContactsWhiteUrl,
        IconQRCodeWhite: IconQRCodeWhiteUrl,
        IconItemsWhite: IconItemsWhiteUrl
      }
    };
  },
  methods: {
    routerPushHandler(target) {
      switch (target) {
        case 'Message':
          if (this.$route.name === 'sa-msg-manager-index') return;
          this.$router.push({ name: 'sa-msg-manager-index' });
          break;
        case 'Contacts':
          if (this.$route.name === 'sa-contacts-index') return;
          this.$router.push({ name: 'sa-contacts-index' });
          break;
        case 'QRCode':
          if (this.$route.name === 'sa-qr-code') return;
          this.$router.push({ name: 'sa-qr-code' });
          break;
        case 'Items':
          if (this.$route.name === 'sa-items-list-index') return;
          this.$router.push({ name: 'sa-items-list-index' });
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style>

</style>
